import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const TeamsModal = ({ onDismiss, show }) => {
  const { t } = useTranslation();

  return (
    <Modal onDismiss={onDismiss} show={show}>
      <div className="modal-header">
        <h4 className="modal-title">{t(`Teams`)}</h4>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-hidden="true"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
      <div className="modal-body">
        <p>
          {t(`By default your game can accomodate 1 team - you! In order to allow more
          teams to participate, you will need to purchase a license.`)}
        </p>
        <ul>
          <li>
            {t(`For more than 20 teams, we recommend you talk to a member of our sales
            team.`)}
          </li>
          <li>
            {t(`For the purpose of billing, a team is defined by a signed in device.
            For example, if you have 4 players exploring together but using one
            device/one account to submit responses then they count as 1 team.`)}
          </li>
          <li>
            <span dangerouslySetInnerHTML={{__html: t(`Need more than 20 teams? You're bigger than most, so contact us at`)}} />{" "}
            <a href="mailto:info@socialscavenger.com">info@socialscavenger.com</a>{" "}
            {t(`for volume pricing`)}.
          </li>
          <li>
            {t(`When you reach the end of your limit, teams will be unable to join
            your game - so make sure to be conservative in your estimates.`)}
          </li>
          <li>
            {t(`If you have already paid and wish to adjust your limits, please`)}{" "}
            <a href="mailto:info@socialscavenger.com">{t(`contact our support team`)}</a>
            .
          </li>
        </ul>
      </div>
      <div className="modal-footer">
        <Button color="dark" data-dismiss="modal" onClick={onDismiss}>
          {t(`Close`)}
        </Button>
      </div>
    </Modal>
  )
};

export default TeamsModal;
